var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('q-inner-loading',{staticClass:"loading_z_index",attrs:{"showing":_vm.appEnv.isBusy}},[_c('q-spinner',{attrs:{"color":"primary","size":"100px"}})],1),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }